<ng-template #edicion [ngIf]="modoVisualizacion === 'edicion'">
    <ng-template #add [ngIf]="mediaElement == null || mediaElement.type == ''">
        <div class="card mb-4 box-shadow">
            <button class="btn btn-light" data-toggle="collapse" attr.data-target="#addmedia-{{mediaId}}">
                <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus-circle" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                        d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd"
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg>
                Añadir sección
            </button>
            <div id="addmedia-{{mediaId}}" class="collapse">
                <div class="container">
                    <div class="row">
                        <button class="btn btn-light col-md-3 d-flex justify-content-center" (click)="setType('text')">
                            <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-textarea-t"
                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd"
                                    d="M1.5 2.5A1.5 1.5 0 0 1 3 1h10a1.5 1.5 0 0 1 1.5 1.5v3.563a2 2 0 0 1 0 3.874V13.5A1.5 1.5 0 0 1 13 15H3a1.5 1.5 0 0 1-1.5-1.5V9.937a2 2 0 0 1 0-3.874V2.5zm1 3.563a2 2 0 0 1 0 3.874V13.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9.937a2 2 0 0 1 0-3.874V2.5A.5.5 0 0 0 13 2H3a.5.5 0 0 0-.5.5v3.563zM2 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                <path
                                    d="M11.434 4H4.566L4.5 5.994h.386c.21-1.252.612-1.446 2.173-1.495l.343-.011v6.343c0 .537-.116.665-1.049.748V12h3.294v-.421c-.938-.083-1.054-.21-1.054-.748V4.488l.348.01c1.56.05 1.963.244 2.173 1.496h.386L11.434 4z" />
                            </svg>
                        </button>
                        <input type="file" id="add-audio-{{mediaId}}" accept=".mp3,.m4a" hidden (change)="getAudio($event)" />
                        <label style="margin-bottom: 0;" id="add-audio-label" for="add-audio-{{mediaId}}"
                            class="btn btn-light col-md-3 d-flex justify-content-center">
                            <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-mic" fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd"
                                    d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z" />
                                <path fill-rule="evenodd"
                                    d="M10 8V3a2 2 0 1 0-4 0v5a2 2 0 1 0 4 0zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3z" />
                            </svg>
                        </label>
                        <button class="btn btn-light col-md-3 d-flex justify-content-center" (click)="setType('video')">
                            <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-camera-video"
                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd"
                                    d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175l3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z" />
                            </svg>
                        </button>
                        <input type="file" id="add-imagen-{{mediaId}}" hidden accept=".jpg,.png,.jpeg"
                            (change)="getImage($event)" />
                        <label style="margin-bottom: 0;" id="add-imagen-label" for="add-imagen-{{mediaId}}"
                            class="btn btn-light col-md-3 d-flex justify-content-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" fill="currentColor"
                                class="bi bi-card-image" viewBox="0 0 16 16">
                                <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                <path
                                    d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54A.505.505 0 0 1 1 12.5v-9a.5.5 0 0 1 .5-.5h13z" />
                            </svg>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #text [ngIf]="mediaElement != null && mediaElement.type === 'text'">
        <div class="modal-content">
            <div class="modal-header">
                <input type="text" class="form-control" placeholder="Titulo del texto" [(ngModel)]="mediaElement.fileTitle" aria-describedby="basic-addon2">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="delete.emit()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ckeditor [editor]="Editor" [data]="mediaElement.text" (change)="onEditText($event)"></ckeditor>
            </div>
        </div>
        <br>
    </ng-template>

    <ng-template #audio [ngIf]="mediaElement != null && mediaElement.type === 'audio'">
        <div class="modal-content">
            <div class="modal-header">
                <input type="text" class="form-control" placeholder="Titulo del audio" [(ngModel)]="mediaElement.fileTitle" aria-describedby="basic-addon2">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="delete.emit()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body d-flex justify-content-center">
                <audio controls>  
                    <source [src]="mediaElement.urlsanitizer" type="audio/ogg">  
                    <source [src]="mediaElement.urlsanitizer" type="audio/mpeg">
                    <source [src]="mediaElement.urlsanitizer" type="audio/m4a">
                    Your browser does not support the audio element.
                </audio>
            </div>
        </div>
        <br>
    </ng-template>

    <ng-template #video [ngIf]="mediaElement != null && mediaElement.type === 'video'">
        <div class="modal-content">
            <div class="modal-header">
                <input type="text" class="form-control" placeholder="Titulo del video" [(ngModel)]="mediaElement.fileTitle" aria-describedby="basic-addon2">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="delete.emit()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="container">
                    <div class="row">
                        <ng-container *ngIf="mediaElement.videoType == ''">
                            <div class="col-md-6 d-flex justify-content-center">
                                <input type="file" id="add-video-{{mediaId}}" accept=".mp4" hidden
                                    (change)="getVideo($event)" />
                                <label id="add-video-label" for="add-video-{{mediaId}}"
                                    class="btn btn-light d-flex justify-content-center">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-upload"
                                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                        <path fill-rule="evenodd"
                                            d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                                    </svg>
                                    Elige archivo
                                </label>
                            </div>
                            <div class="col-md-6 d-flex justify-content-center">
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control" placeholder="Inserta URL"
                                        [(ngModel)]="mediaElement.url" aria-describedby="basic-addon2">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary" type="button"
                                            [disabled]="mediaElement.url == null || mediaElement.url.length==0"
                                            (click)="setVideoMode('url')">
                                            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check"
                                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd"
                                                    d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="mediaElement.videoType != null && mediaElement.videoType == 'local'">
                            <video *ngIf="mediaElement.urlsanitizer" width="100%" autoplay="autoplay" controls
                                style="margin-top: 50px; margin-bottom: 20px;">
                                <source [src]="mediaElement.urlsanitizer" type="video/mp4">
                            </video>
                        </ng-container>
                        <ng-container *ngIf="mediaElement.videoType != null && mediaElement.videoType == 'url'">
                            <div [innerHtml]="mediaElement.urlsanitizer"></div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <br>
    </ng-template>

    <ng-template #image [ngIf]="mediaElement != null && mediaElement.type === 'image'">
        <div class="modal-content">
            <div class="modal-header">
                <input type="text" class="form-control" placeholder="Titulo de la imagen" [(ngModel)]="mediaElement.fileTitle"
                    aria-describedby="basic-addon2">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="delete.emit()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body d-flex justify-content-center">
                <img class="image-crop" [src]="mediaElement.urlsanitizer" width="100%">
            </div>
        </div>
        <br>
    </ng-template>
</ng-template>

<ng-template #vista [ngIf]="modoVisualizacion === 'vista'">

    <ng-template #text [ngIf]="mediaElement != null && mediaElement.type === 'text'">
        <div class="modal-content">
            <div class="modal-header">
                <input type="text" readonly class="form-control-plaintext" placeholder="Titulo del texto" [value]="mediaElement.fileTitle"
                    aria-describedby="basic-addon2">
            </div>
            <div class="modal-body">
                <div [innerHTML]="mediaElement.text"></div>
            </div>
        </div>
        <br>
    </ng-template>

    <ng-template #audio [ngIf]="mediaElement != null && mediaElement.type === 'audio'">
        <div class="modal-content">
            <div class="modal-header">
                <input type="text" readonly class="form-control-plaintext" placeholder="Titulo del audio" [value]="mediaElement.fileTitle"
                    aria-describedby="basic-addon2">
            </div>
            <div class="modal-body d-flex justify-content-center">
                <audio controls>  
                    <source [src]="mediaElement.urlsanitizer" type="audio/ogg">  
                    <source [src]="mediaElement.urlsanitizer" type="audio/mpeg">
                    <source [src]="mediaElement.urlsanitizer" type="audio/m4a">
                    Your browser does not support the audio element.
                </audio>
            </div>
        </div>
        <br>
    </ng-template>

    <ng-template #video [ngIf]="mediaElement != null && mediaElement.type === 'video'">
        <div class="modal-content">
            <div class="modal-header">
                <input type="text" readonly class="form-control-plaintext" placeholder="Titulo del video" [value]="mediaElement.fileTitle"
                    aria-describedby="basic-addon2">
            </div>
            <div class="modal-body">
                <div class="container">
                    <div class="row">
                        <ng-container *ngIf="mediaElement.videoType != null && mediaElement.videoType == 'local'">
                            <video *ngIf="mediaElement.urlsanitizer" width="100%" autoplay="autoplay" controls
                                style="margin-top: 50px; margin-bottom: 20px;">
                                <source [src]="mediaElement.urlsanitizer" type="video/mp4">
                            </video>
                        </ng-container>
                        <ng-container *ngIf="mediaElement.videoType != null && mediaElement.videoType == 'url'">
                            <div [innerHtml]="mediaElement.urlsanitizer"></div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <br>
    </ng-template>

    <ng-template #image [ngIf]="mediaElement != null && mediaElement.type === 'image'">
        <div class="modal-content">
            <div class="modal-header">
                <input type="text" readonly class="form-control-plaintext" placeholder="Titulo de la imagen" [value]="mediaElement.fileTitle"
                    aria-describedby="basic-addon2">
            </div>
            <div class="modal-body d-flex justify-content-center">
                <img class="image-crop" [src]="mediaElement.urlsanitizer" width="100%">
            </div>
        </div>
        <br>
    </ng-template>
</ng-template>